module.exports = __webpack_public_path__ + "img/member14.076be804.png";